import { SHA256 } from 'crypto-js';
import { windowBreakpoints } from '../hooks/useDeviceSize';
import { AppInfo } from '../constants';

export const titleCase = (str: string | undefined) =>
  str?.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase());

export const spaceCase = (str?: string) =>
  str
    ?.replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')
    .replace(/([0-9])([a-zA-Z])/g, '$1 $2')
    .replace(/([a-zA-Z])([0-9])/g, '$1 $2')
    .trim();

export const formatCash = (Value: number | string, decimals = 0) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: decimals,
  }).format(Value as any);

export const getSha256 = (str: string) => SHA256(str).toString();

export const commifyNumber = (num: number | string | undefined) => (num || '0').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export const responsiveStyle = (viewportSize: windowBreakpoints, properties: any) => {
  const outputStyle = {} as any;

  if (!viewportSize.isDesktop && !viewportSize.isMobile && !viewportSize.isTablet) {
    return properties;
  }

  Object.keys(properties).forEach((index) => {
    let property = properties[index];
    property = {
      ...property,
      ...(viewportSize.isDesktop ? property['@desktop'] : property['!desktop']),
      ...(viewportSize.isMobile ? property['@mobile'] : property['!mobile']),
      ...(viewportSize.isTablet ? property['@tablet'] : property['!tablet']),
    };
    outputStyle[index] = property;
  });

  return outputStyle;
};

export const getToken = () => {
  return localStorage.getItem(`${AppInfo.companyName}-auth`);
};

export const setCookie = (name: string, value: string): void => {
  const cookieValue = encodeURIComponent(value);
  const cookieName = encodeURIComponent(name);
  const expires = new Date();
  expires.setDate(expires.getDate() + 10);

  const expiresString = expires.toUTCString();

  if (document.domain === 'localhost') {
    document.cookie = `${cookieName}=${cookieValue};expires=${expiresString};path=/;`;
  } else {
    const domain = window.location.hostname.split('.').slice(-2).join('.');
    document.cookie = `${cookieName}=${cookieValue};expires=${expiresString};domain=${domain};path=/;`;
  }
};

export const removeCookie = (name: string): void => {
  if (document.domain === 'localhost') {
    document.cookie = name + '=; Max-Age=0';
  } else {
    const domain = window.location.hostname.split('.').slice(-2).join('.');
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.${domain}`;
  }
};
export const getQueryStringOfUrl = (convertToJson: boolean = false, url: string | undefined = undefined): any => {
  let queryString = url;
  if (url) {
    if (url.indexOf('?') === -1) {
      return convertToJson ? {} : '';
    }
    queryString = url;
  } else {
    queryString = window.location.href.split('?')[1];
  }
  if (!queryString) {
    return convertToJson ? {} : '';
  }

  return convertToJson ? queryStringToJSON(queryString) : `?${queryString}`;
};
export function queryStringToJSON(queryString: any): object {
  if (queryString.indexOf('?') > -1) {
    queryString = queryString.split('?')[1];
  }
  var pairs = queryString.split('&');
  var result = {};
  pairs.forEach(function (pair: any) {
    pair = pair.split('=');
    //@ts-ignore
    result[pair[0]] = decodeURIComponent(pair[1] || '');
  });
  return result;
}
export const windowRedirect = (url: string) => {
  const queryString = getQueryStringOfUrl(false);
  if (queryString.toString().length > 0) {
    window.location.href = `${url}${queryString}`;
  } else {
    window.location.href = `${url}`;
  }
};
